import { inject, Pipe, PipeTransform } from '@angular/core';

import { LanguageService } from '@evc/platform';

import { DATE_FORMATS, DateFormat, format } from '../../utils/date.utils';

/**
 * Format a date according to the specified format string
 * - Default format is a long date with time
 * - Default locale is automatically detected
 * - UTC is disabled by default
 * @example {{ element.updatedAt | dateFormat:DATE_FORMATS.DateLong:'en-US':false }}
 */
@Pipe({
  name: 'dateFormat',
  standalone: true,
})
export class DateFormatPipe implements PipeTransform {
  readonly #languageService = inject(LanguageService);

  readonly #locale = this.#languageService.locale;
  readonly DATE_FORMATS = DATE_FORMATS;

  transform(
    date: Date | string | number,
    formatStr: DateFormat = DATE_FORMATS.DateWithTime,
    locale?: string,
    utc?: boolean,
  ): string {
    if (!date) return '';

    locale ??= this.#locale();

    return format(date, locale, formatStr, utc);
  }
}
